<div class="verification-container">
    <div class="verification-checks">
        <mat-checkbox
            id="check-keycloak-{{ orgId() }}"
            [checked]="verificationChecks()?.keycloak"
            [disabled]="isCheckboxDisabled('keycloak')"
            (change)="toggle('keycloak', $event.checked)"
            >Keycloak</mat-checkbox
        >
        <mat-checkbox
            id="check-cors-{{ orgId() }}"
            [checked]="verificationChecks()?.cors"
            [disabled]="isCheckboxDisabled('cors')"
            (change)="toggle('cors', $event.checked)"
            >CORS</mat-checkbox
        >
        <mat-checkbox
            id="check-adyen-{{ orgId() }}"
            [checked]="isAdyenChecked()"
            [disabled]="isCheckboxDisabled('adyen')"
            [matTooltip]="adyenTooltip()"
            (change)="toggle('adyen', $event.checked)"
            >ADYEN</mat-checkbox
        >
        <mat-checkbox
            id="check-devops-{{ orgId() }}"
            [checked]="verificationChecks()?.devops"
            [disabled]="isCheckboxDisabled('devops')"
            (change)="toggle('devops', $event.checked)"
            >DEV OPS (domain)</mat-checkbox
        >
        <mat-checkbox
            id="check-qa-{{ orgId() }}"
            [checked]="verificationChecks()?.qa"
            [disabled]="isCheckboxDisabled('qa')"
            (change)="toggle('qa', $event.checked)"
            >QA</mat-checkbox
        >
    </div>

    <span class="url-status-badge" [ngClass]="isComplete() ? 'url-status-ready' : 'url-status-pending'">
        {{ badgeLabel() }}
    </span>
</div>
